import { useMemo, useState, useRef } from 'react';
import { debounce } from '@mui/material';

export const useVAutocomplete = (onSelectOption, searchFunction, optionLabelKey) => {
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const inputRef = useRef(null);

  const searchItems = async (query) => {
    setSearchQuery(query);

    if (!query) {
      setOptions([]);
      return;
    }
    setIsLoading(true);

    const results = await searchFunction(query);
    if (results) {
      setOptions(
        results.map((item) => ({
          label: item[optionLabelKey],
          ...item,
        }))
      );
    } else {
      setOptions([]);
    }

    setIsLoading(false);
  };

  const onChangeSearch = useMemo(
    () => debounce(({ target: { value } }) => searchItems(value), 500),
    [searchFunction, optionLabelKey]
  );

  const handleOpenAutocomplete = () => setOpenAutocomplete(true);

  const clearAutocomplete = () => {
    setSearchQuery('');
    setOptions([]);
    setOpenAutocomplete(false);
    setIsLoading(false);
    inputRef.current.blur();
  };

  const handleCloseAutocomplete = () => {
    onSelectOption(null);
    clearAutocomplete();
  };

  const handleSelectOption = (option) => {
    onSelectOption(option);
    clearAutocomplete();
  };

  return {
    inputRef,
    openAutocomplete,
    onChangeSearch,
    options,
    searchQuery,
    isLoading,
    handleOpenAutocomplete,
    handleCloseAutocomplete,
    setIsLoading,
    handleSelectOption,
  };
};
